"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalError_constants_exports = {};
__export(GlobalError_constants_exports, {
  errorCodeMessage: () => errorCodeMessage
});
module.exports = __toCommonJS(GlobalError_constants_exports);
var errorCodeMessage = function errorCodeMessage2(code) {
  return {
    400: "400 | The requested URL is invalid.",
    401: "401 | We\u2019re sorry, you do not have permission to access the requested URL.",
    403: "403 | We\u2019re sorry, you do not have permission to access the requested URL.",
    404: "404 | This page could not be found.",
    408: "408 | The site connection timed out, please reload the page or try again later."
  }[code] || "".concat(code, " | We\u2019re sorry, an unexpected error has occurred.");
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  errorCodeMessage
});
//# sourceMappingURL=GlobalError.constants.js.map